"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PageWrapper = _interopRequireDefault(require("../Grid/PageWrapper"));

var _Grid = _interopRequireDefault(require("../Grid/Grid"));

var utils = _interopRequireWildcard(require("../../shared"));

var _ModalTitle = _interopRequireDefault(require("./ModalTitle"));

var _ModalSubtitle = _interopRequireDefault(require("./ModalSubtitle"));

var _ModalDismiss = _interopRequireDefault(require("./ModalDismiss"));

require("./Modal.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
Component to display a Modal
*/
function Modal(_ref) {
  var Component = _ref.componentEl,
      className = _ref.className,
      onDismiss = _ref.onDismiss,
      children = _ref.children,
      renderNode = _ref.renderNode,
      fullWidth = _ref.fullWidth,
      showDismiss = _ref.showDismiss,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "className", "onDismiss", "children", "renderNode", "fullWidth", "showDismiss"]);

  var cssClasses = ['st_modal'];
  cssClasses = utils.classNames.addClassNames(className, cssClasses); // handle when X is clicked to manually close Modal

  var handleDismiss = (0, _react.useCallback)(function () {
    if (onDismiss) onDismiss();
  }, [onDismiss]);
  var listenKeyboard = (0, _react.useCallback)(function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      handleDismiss();
    }
  }, [handleDismiss]); // listen for Esc key

  (0, _react.useEffect)(function () {
    window.addEventListener('keydown', listenKeyboard);
    return function () {
      return window.removeEventListener('keydown', listenKeyboard);
    };
  }, [listenKeyboard]);

  var content = /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), showDismiss && /*#__PURE__*/_react["default"].createElement(Modal.Dismiss, {
    className: "st_modal__dismiss--placed",
    onClick: handleDismiss
  }), !fullWidth && /*#__PURE__*/_react["default"].createElement(_PageWrapper["default"], {
    className: "st_modal__content"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], null, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Col, {
    xs: 12,
    sm: 8,
    smOffset: 2,
    md: 6,
    mdOffset: 3
  }, children)))), fullWidth && children);

  if (!renderNode) return content;
  return _reactDom["default"].createPortal(content, renderNode);
}

Modal.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: utils.componentEl.props,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** callback when Modal is dismissed, either via the X icon, or by pressing Esc */
  onDismiss: _propTypes["default"].func,

  /** node where modal should be rendered */
  renderNode: _propTypes["default"].any,

  /** whether modal should go edge to edge */
  fullWidth: _propTypes["default"].bool,

  /** whether to show dismiss button automatically */
  showDismiss: _propTypes["default"].bool
};
Modal.defaultProps = {
  componentEl: utils.componentEl.defaults,
  className: null,
  onDismiss: function onDismiss() {
    return null;
  },
  renderNode: null,
  fullWidth: false,
  showDismiss: true
};
Modal.displayName = 'Modal';
Modal.Title = _ModalTitle["default"];
Modal.Subtitle = _ModalSubtitle["default"];
Modal.Dismiss = _ModalDismiss["default"];
var _default = Modal;
exports["default"] = _default;